import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { POLICIES, BUSINESS } from "@/data/policies";

export default function PolicyPage({ policy }) {
  const data = POLICIES[policy];

  useEffect(() => {
    if (data) {
      document.title = `${data.title} | ${BUSINESS.name}`;
    }
  }, [data]);

  if (!data) return null;

  return (
    <div data-testid={`policy-page-${policy}`}>
      <Navbar />

      <section className="bg-primary text-primary-foreground py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl md:text-5xl font-bold" data-testid="policy-title">
            {data.title}
          </h1>
          <p className="text-primary-foreground/80 mt-3 text-sm">Last updated: {BUSINESS.lastUpdated}</p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-base text-muted-foreground leading-relaxed mb-10">{data.intro}</p>

          <div className="space-y-8">
            {data.sections.map((section, idx) => (
              <div key={idx}>
                <h2 className="font-heading text-xl md:text-2xl font-semibold text-primary mb-3">
                  {section.heading}
                </h2>
                {section.body.length > 1 ? (
                  <ul className="list-disc pl-5 space-y-2 text-foreground/90 leading-relaxed">
                    {section.body.map((line, i) => (
                      <li key={i}>{line}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-foreground/90 leading-relaxed">{section.body[0]}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
